module.exports = __webpack_public_path__ + "img/4.209f68f6.svg";